import React from 'react';
import { WorkshopProgressProvider, useWorkshopProgress } from '@/contexts/WorkshopProgressContext';
import WorkshopLanding from '@/components/workshop/steps/WorkshopLanding';
import WorkshopChallenge from '@/components/workshop/steps/WorkshopChallenge';
import WorkshopPractice from '@/components/workshop/steps/WorkshopPractice';
import WorkshopTransformation from '@/components/workshop/steps/WorkshopTransformation';
import WorkshopAssessment from '@/components/workshop/steps/WorkshopAssessment';
import WorkshopCTA from '@/components/workshop/steps/WorkshopCTA';

const WorkshopRouter: React.FC = () => {
  const { state } = useWorkshopProgress();

  const renderCurrentStep = () => {
    switch (state.currentStep) {
      case 'landing':
        return <WorkshopLanding />;
      case 'challenge':
        return <WorkshopChallenge />;
      case 'practice':
        return <WorkshopPractice />;
      case 'transformation':
        return <WorkshopTransformation />;
      case 'assessment':
        return <WorkshopAssessment />;
      case 'cta':
        return <WorkshopCTA />;
      default:
        return <WorkshopLanding />;
    }
  };

  return (
    <div className="workshop-container">
      {renderCurrentStep()}
    </div>
  );
};

const DemoOption3: React.FC = () => {

  return (
    <WorkshopProgressProvider>
      <WorkshopRouter />
    </WorkshopProgressProvider>
  );
};

export default DemoOption3;